SET_USER_ACCOUNT_BILLING_SUBSCRIPTIONS_PROCESSING